/**
 * Controller for the Delete Tab Modal.
 * This class handles the logic for the modal dialog that confirms deletion of a tab.
 * 
 * @class DeleteTabModalController
 * @param {Object} $scope - The AngularJS scope object.
 * @param {Object} $uibModalInstance - The instance of the modal dialog.
 */
class DeleteTabModalController {
    constructor($scope, $uibModalInstance) {
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;

        // Bind methods to the controller instance to maintain context
        this.$scope.onCancelButton = this.onCancelButton.bind(this);
        this.$scope.onDelete = this.onDelete.bind(this);
    }

    /**
     * Handles the cancel button click event.
     * Sets the delete flag to false and dismisses the modal.
     * 
     * @method onCancelButton
     */
    onCancelButton() {
        this.$uibModalInstance.close(false);
    }

    /**
     * Handles the delete button click event.
     * Sets the delete flag to true and dismisses the modal.
     * 
     * @method onDelete
     */
    onDelete() {
        this.$uibModalInstance.close(true);
    }
}

export default DeleteTabModalController;